import { useEffect, useState } from "react";

/**
 * How many pixels of the layout viewport the on-screen keyboard currently covers.
 *
 * iOS never shrinks the layout viewport for the keyboard, so a `position: fixed;
 * bottom: 0` bar ends up behind it — worst in a standalone PWA, where there's no
 * browser chrome absorbing any of it. visualViewport reports what's actually
 * visible, so a bottom bar can be lifted by exactly this much with
 * `transform: translateY(-inset)`.
 *
 * Returns 0 when disabled, when the keyboard is closed, or where visualViewport is
 * unavailable (the bar then just stays bottom-fixed).
 */
export default function useKeyboardInset(enabled = true) {
  const [inset, setInset] = useState(0);

  useEffect(() => {
    const viewport = window.visualViewport;
    if (!enabled || !viewport) {
      setInset(0);
      return;
    }
    const update = () => {
      const covered = window.innerHeight - (viewport.height + viewport.offsetTop);
      setInset(Math.max(0, Math.round(covered)));
    };
    update();
    viewport.addEventListener("resize", update);
    viewport.addEventListener("scroll", update);
    return () => {
      viewport.removeEventListener("resize", update);
      viewport.removeEventListener("scroll", update);
    };
  }, [enabled]);

  return inset;
}
